"use client";

import { useState } from "react";
import { createPortal } from "react-dom";
import "./RejectClinicModal.css";

const RejectClinicModal = ({ isOpen, onClose, clinic, onConfirm }) => {
  const [rejectionReason, setRejectionReason] = useState("");

  if (!isOpen) return null;

  const handleConfirm = () => {
    const reason = rejectionReason.trim() || "No reason provided";
    onConfirm(reason);
    setRejectionReason("");
    onClose();
  };

  const handleCancel = () => {
    setRejectionReason("");
    onClose();
  };

  const modalContent = (
    <div className="reject-clinic-modal-overlay" onClick={handleCancel}>
      <div className="reject-clinic-modal" onClick={(e) => e.stopPropagation()}>
        <div className="reject-clinic-modal-header">
          <button className="reject-clinic-modal-close" onClick={handleCancel}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div className="reject-clinic-modal-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          </div>
          <h2 className="reject-clinic-modal-title">Reject Clinic</h2>
        </div>

        <div className="reject-clinic-modal-content">
          <p className="reject-clinic-modal-message">
            Are you sure you want to reject this clinic?
          </p>
          <div className="reject-clinic-modal-clinic-info">
            <strong>{clinic.name_en || clinic.name_ar}</strong>
            {clinic.name_ar && clinic.name_en && (
              <span className="reject-clinic-modal-clinic-name-ar"> ({clinic.name_ar})</span>
            )}
            {clinic.registration_number && (
              <div className="reject-clinic-modal-clinic-id">
                Registration: {clinic.registration_number}
              </div>
            )}
          </div>
          
          <div className="reject-clinic-modal-reason-section">
            <label className="reject-clinic-modal-label">
              Rejection Reason <span className="reject-clinic-modal-label-optional">(Optional)</span>
            </label>
            <textarea
              className="reject-clinic-modal-textarea"
              placeholder="Provide a reason for rejection..."
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              rows="4"
            />
          </div>

          <p className="reject-clinic-modal-warning">
            The clinic will be marked as rejected and will not be visible to users. The clinic owner can resubmit for review.
          </p>
        </div>

        <div className="reject-clinic-modal-actions">
          <button
            className="reject-clinic-modal-btn reject-clinic-modal-btn-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className="reject-clinic-modal-btn reject-clinic-modal-btn-confirm"
            onClick={handleConfirm}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            Reject Clinic
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default RejectClinicModal;

